import React, { useContext, useEffect, useState } from "react";
import { Calendar } from "primereact/calendar";
import { Button, Form, FormGroup, FormLabel } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Field, FormikProvider, useFormik } from "formik";
import Shopkeeper from "../../Services/shopkeeperServices";
import Shop from "../../Services/shopServices";
import FormSelectField from "../../Components/FormSelectField";
import Payment from "../../Services/paymentServices";
import { AuthContext } from "../../Auth/Context/AuthContext";
import Account from "../../Services/accountServices";
import TitleHeader from "../accounts/Components/TitleHeader";
import { message } from "antd";
function AddRent(props) {
  const shopKeeperId = useParams().id;
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [shops, setShops] = useState([]);
  const [shopkeepers, setShopkeepers] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [date, setDate] = useState();
  const shop = location.state?.shop;
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      shopkeeper: [],
      account: [],
      memo: "",
      amount: "",
      shop: [],
      currencyRate: "",
    },
    onSubmit: (values, { setSubmitting, setFieldError }) => {
      if (values.amount < 0 || values.currencyRate < 0)
        return message.warning("Amount must be a positive number");
      const data = {
        ...values,
        accountName: accounts.find((op) => op.id === parseInt(values.account))
          ?.name,
        accountId: values.account,
        shopkeeperName: shopkeepers.find(
          (op) => op.id === parseInt(values.shopkeeper)
        )?.name,
        shopkeeperId: values.shopkeeper,
        shopName: shops.find((op) => op.id === parseInt(values.shop))?.name,
        shopId: values.shop,
        date,
        branchId: user.branchId,
      };
      console.log("VVVVVVVVVVVVVVV", data);
      setLoading(true);
      Payment.pay(data)
        .then((data) => {
          if (data.data.status === "Fail") {
            setLoading(false);
            return message.error("Failed");
          }
          navigate("/shopkeeper-list");
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    },
  });
  const {
    errors,
    touched,
    isSubmitting,
    handleSubmit,
    setFieldValue,
    handleChange,
  } = formik;

  const getAllShops = async () => {
    await Shop.getAllShops().then((shops) => {
      console.log("Available Free Shops: ", shops.data);
      setShops(shops?.data);
    });
  };
  const getAllShopkeepers = async () => {
    await Shopkeeper.getAll().then((shops) => {
      console.log("Available Free Shopkeepers: ", shops.data);
      setShopkeepers(shops?.data);
    });
  };
  const getAccounts = async () => {
    await Account.getAccountsByType("Bank and Cash")
      .then((response) => {
        setAccounts(response.data);
      })
      .catch((error) => {
        console.log("____ error ", error);
      });
  };
  useEffect(() => {
    getAllShops();
    getAllShopkeepers();
    getAccounts();
  }, []);

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="page-wrapper">
        {/* <Toast ref={toast} /> */}
        <div class="content">
          <TitleHeader title="Add Payment" />
          {shop && (
            <h3>{`Payment for Shop: F${shop.buildingFloorFloorNumber}-${shop.name}-${shop.shopNumber}`}</h3>
          )}
          <div class="card">
            <div class="card-body">
              <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                  <FormGroup className="mb-3">
                    <div class="row">
                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Shopkeeper</FormLabel>
                          <FormSelectField
                            type="select"
                            name="shopkeeper"
                            setFieldValue={setFieldValue}
                            required
                          >
                            <option value="">Select</option>
                            {shopkeepers &&
                              shopkeepers.map((shopkeeper) => (
                                <option value={shopkeeper.id}>
                                  {shopkeeper.name}
                                </option>
                              ))}
                          </FormSelectField>
                        </div>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Shop</FormLabel>
                          <FormSelectField
                            type="select"
                            name="shop"
                            setFieldValue={setFieldValue}
                            required
                          >
                            <option value="">Select</option>
                            {shops &&
                              shops.map((shop) => (
                                <option value={shop.id}>
                                  {shop.shop_number}-{shop.name}
                                </option>
                              ))}
                          </FormSelectField>
                        </div>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Amount</FormLabel>
                          <Field
                            name="amount"
                            type="number"
                            required
                            placeholder="Amount (0)"
                          />
                        </div>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Currency Rate</FormLabel>
                          <Field
                            type="number"
                            name="currencyRate"
                            required
                            placeholder="Currency Rate e.g (83.5)"
                          />
                        </div>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Account</FormLabel>
                          <FormSelectField
                            type="select"
                            name="account"
                            setFieldValue={setFieldValue}
                          >
                            <option value="">Select</option>
                            {accounts &&
                              accounts.map((account) => (
                                <option value={account.id}>
                                  {account.name}
                                </option>
                              ))}
                          </FormSelectField>
                        </div>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Memo</FormLabel>
                          <Field
                            type="text"
                            name="memo"
                            required
                            placeholder="Memo"
                          />
                        </div>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Date</FormLabel>
                          <Calendar
                            name="date"
                            onChange={(e) =>
                              setDate(e.target.value.toISOString())
                            }
                            showIcon
                            placeholder="Date"
                          />
                        </div>
                      </div>

                      <div class="col-lg-12">
                        <Button className="btn btn-submit me-2" type="submit">
                          {shopKeeperId ? "Update" : "Save"}
                        </Button>
                        <Button href="rent-list" className="btn btn-cancel">
                          Cancel
                        </Button>
                      </div>
                    </div>
                  </FormGroup>
                </Form>
              </FormikProvider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddRent;
